import api from './axios';

export const getXmitDirectoryApi = (params = {}) => api.get('/admin/xmit', { params });
export const getXmitDetailApi = (xmitNumber) => api.get(`/admin/xmit/${encodeURIComponent(xmitNumber)}`);
export const provisionXmitApi = () => api.post('/admin/xmit/provision');
export const assignDirectoryXmitApi = (xmitNumber, body) =>
  api.post(`/admin/xmit/${encodeURIComponent(xmitNumber)}/assign`, body);
export const removeDirectoryXmitApi = (xmitNumber, confirmation) =>
  api.delete(`/admin/xmit/${encodeURIComponent(xmitNumber)}`, { data: { confirmation } });
